export enum ProfanityRuleStatus {
  ACCEPTED = 'accepted',
  REQUIRES_MANUAL_CHECK = 'requires_manual_check',
  REJECTED = 'rejected',
}

export interface ProfanityRuleItem {
  // Score band: [min_threshold, max_threshold). Bands must tile [0, max_score] with no gaps/overlap.
  min_threshold: number
  max_threshold: number
  rule_status: ProfanityRuleStatus
}

export interface ProfanityCheckRule {
  company_id: string
  max_score: number
  rules: ProfanityRuleItem[]
}
